import React, { Fragment } from 'react';
import { Container, Row, Col, Button, Progress, Label, Form, FormGroup, Input, TabContent, TabPane, Nav, NavItem, NavLink, Card } from 'reactstrap';
import { useDashboardCard } from '../../../hooks/dashboard/useDashboardCard';
import { ModalCheckSpecimen2 } from './ModalCheckSpecimen2';
import { ModalPreViewMedicalOrder } from './ModalPreViewMedicalOrder.jsx';
import { ModalPrintI } from './ModalPrintI.jsx';
import { ModalViewInvoice } from './ModalViewInvoice.jsx';
import './styleDashboard.css';
import { ModalHistoricSample } from './ModalHistoricSample';
import { ModalTrazabilidadSampleDashboard } from './ModalTrazabilidadSampleDashboard';
import 'moment/locale/es';
import Select from 'react-select';
import { ModalCheckDelivery } from './ModalCheckDelivery';
import { ModalSendEmail } from './ModalSendEmail';
import { ModalExamsEmail } from './ModalExamsEmail';
import "../../../assets/css/pantalla1.css";
import { ModalSendWhatsapp } from './ModalSendWhatsapp.jsx';
import { ListOptionsStatus } from '../../../constant/dashboard.jsx';
import { cedimi } from '../../../constant/globalConstantsTypeClients'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import img0 from '../../../assets/images/toma/flask-0.svg'
import img3 from '../../../assets/images/toma/flask-3.svg'
import img4 from '../../../assets/images/toma/flask-4.svg'
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';






const Sample = (props) => {

	const {
		//*DELIVERY
		toggleCheckDelivery, handleCheckDelivery, modalCheckDelivery, idWorkOrder,
		getdashboard, nim, handleInputChange, loading, nimData, patientCompany, patientTotal, countTotal, examsAndProfile, orderTotal, orderCancell, totalInvoices,

		//*methods absolutes
		printTicket, printSticker, navigateConfigEtiqueta, navigateUpdate, handleViewTest, handleCloseViewTest, enableViewTest,
		typeModall, modalOrdenMedical, toggleMedical, handleMedical, workMedicalOrderPDF, loadingPdf, workMedicalOrderPDFDownload, changeEstatus, commentPatient,

		//*CHECK SPECIMEN
		handleModalCheckSpecimen, toggleCheckSpecimen, modalCheckSpecimen, specimensUncheck, checkSpecimens, loadingSpecimen, chek,

		//*PRINT PDF INDIVIDUAL
		handleListPrint, typeModalPrintI, modalPrintI, togglePrintI, dataExams, handleCheckProfile, handleCheckAll, handleCheckAllProfile, Impresionbyexam, id_workorder_print, letter,

		//*CONFIGURATION INVOICES AND REPORT
		toggleInvoice, handleInvoice, typeModalInvoice, modalInvoice, InvoicePDF, sendResultForEmail, exportToExcel, nimDataExcel,

		//*TRAZABILIDAd
		typePending, modalPending, toggleHistoric, dataSample, loadingSample, dataSendProcess2, dataSendProcess3, dataTrackingRecepetion, handleTrazabilidad, close, modalProps,
		namePatient, idGender, dataSection, dataID, treeviewRef, itemsTree, changeTree, savePendingMuestra, enable_tracking_toma,

		//*FILTERS DASHBOARD
		mDateRange1, mDateRange2, mSelectStatus, handleSelectValues, handleCleanFilter, viewFormFilters, handleViewFilters, navigateInvoice,

		//*SERVICE EMAIL
		handleSendExam, toggleExamEmail, modalCheckEmail, sendResultEmail, modalExamsEmail, handleListExamEmail, toggleListExamEmail, typeModalExamEmail, id_workorder_send, sendTo, handleFindExam,

		//*FILTER
		refusedGlobal, filterSections, handleFilterSections, maquila, respuestaAPI,

		//*CONFIGURATION SEND WHATSAPP
		handleSendWhatss, modalPreviewSend, toggleModalSend, validNumber, id_patient, sendResultsWhatsapp,

		//*TYPE SERVICE
		handleChangeFilterService, listTypeService, id_type_service, _interfaced_hospital, PrimarycolorLineTab, setPrimarycolorLineTab, handleView, loadingMicro,
		printTicketCedimi,

		//* FILTER ID_USER
		handleSwitchChange, justMe, dataTraceability, loadingTrazability, handleCleanFilterMicro,

		// ! CONFIGURATION MICROSANITARY
		_active_micro, _title_dashboard, _url_helen, exportToExcelTrazability, exportToExcel2, isLoading, enable_whatsapp, _valid_Finance, _finance2,

		// ? CONFIGURATION DATATABLE
		renderStatusTag, globalFilter, setGlobalFilter, filterData, expandedRows2, setExpandedRows2, rowExpansionTemplate2, credit_payment,
		modalFullRef, globalFilter2, setGlobalFilter2, filterData2, expandedRows, setExpandedRows, rowExpansionTemplate, arrayStatus, filterOptions, branchName,
		showInvoiceAlert, toggleAlert, modalAlert, totalClinical, totalMicro, sendConfig, handleSendEmail,
		sending,

		// ? SEND RESULTS

		setStep, setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
		isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount, resetModalExamEmail,
		getFullAuditHistory, getStatus,

		loadingDownloadExams


	} = useDashboardCard();
	// console.log("🚀 ~ Sample ~ viewFormFilters:", viewFormFilters)
	// 	console.log("🍤 respuestaAPI", respuestaAPI);
	// 			console.log("🦄 sendTo", sendTo);
	// 	console.log("🦄 sendResultForEmail", sendResultForEmail);


	// ? CONFIGURATION DATATABLE
	const headerStyle = {
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "10px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
		paddingBottom: "0px"
	};

	const cellStyle = {
		fontSize: "10px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",
		paddingBottom: "0px"


	};

	const getButtonStyle = (bgColor) => ({
		width: "26px",
		height: "26px",
		fontSize: "0.65rem",
		borderRadius: "8px",
		padding: "0",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		border: "none",
		color: "#fff",
		cursor: "pointer",
		backgroundColor: bgColor,
	});

	const getButtonStyle1 = (bgColor) => ({
		width: "26px",
		height: "26px",
		fontSize: "0.65rem",
		borderRadius: "8px",
		padding: "0",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		border: "none",
		color: "#000",
		cursor: "pointer",
		backgroundColor: bgColor,
	});

	const buttonStyle = getButtonStyle("#f97316");
	const buttonStyle2 = getButtonStyle("#0079c7");
	const buttonStyle3 = getButtonStyle("#000");
	const buttonStyle4 = getButtonStyle("#46afe5");
	const buttonStyle5 = getButtonStyle("#000");
	const buttonStyle6 = getButtonStyle("#002940");
	const buttonStyle7 = getButtonStyle1("#ecab0f");
	const buttonStyle8 = getButtonStyle("#51bb25");
	const buttonStyle9 = getButtonStyle("#3b82f6");
	const buttonStyle10 = getButtonStyle("#bd2130");
	const buttonStyle11 = getButtonStyle("#bd2130");

	const typeMenu = localStorage.getItem('menu') === "True";
	const url_helen = localStorage.getItem("url_helen");



	return (
		<Fragment>
			<div className='container-global-zoom' >
				<Col sm="12" md="12" lg="12" className='p-l-0 p-r-0' >
					<TabContent activeTab={"1"}>
						<TabPane className="fade show" tabId="1">
							{
								// * CARDS DASHBOARD
								<Col sm="12">
									<Card className="pt-1 pl-3 pr-3 pb-3 mb-3 shadow-sm rounded"  >
										<Row>
											<Col sm="4">
												<Col sm="12" className="pr-0 pb-3">
													<img
														src={require('../../../assets/images/dashboard/iconBar.svg')}
														style={{ width: '60px' }}
														alt="Branch Icon"
													/>
													<label className='text-center f-w-600 label-dashboard' style={{ fontSize: "16px", color: "#002940" }}>Ordenes de trabajo / Día <b> {orderTotal ?? 0}</b></label>
													<div className="media border-after-xs">
														<div className="align-self-center mr-3">
															<h5 className="mb-0 counter digits">{patientTotal ?? 0}</h5>
														</div>
														<div className="media-body details pl-3 pt-0">
															<span className="mb-1 f-w-600 label-dashboard" style={{ color: "#374558" }} >Pacientes particulares</span>
														</div>
														<div className="media-body align-self-center">
															<i
																style={PrimarycolorLineTab === '1' ? { fontSize: '1.8rem', color: "#6c757d" } : { color: "#6c757d", fontSize: '1.8rem' }}
																className={PrimarycolorLineTab === '1' ? "float-left ml-2 pi pi-users" : "float-left ml-2 pi pi-users"}
															/>
														</div>
													</div>
													<Progress
														value={(patientTotal / orderTotal) * 100}
														className="progress-dashboard"
														style={{ height: '6px', borderRadius: '4px', marginTop: '8px' }}
													/>
												</Col>
												<Col sm="12" className="pr-0">
													<div className="media border-after-xs">
														<div className="align-self-center mr-3">
															<h5 className="mb-0 counter digits">{patientCompany ?? 0}</h5>
														</div>
														<div className="media-body details pl-3 pt-0">
															<span className="mb-1 f-w-600 label-dashboard" style={{ color: "#374558" }}>Pacientes de empresa</span>
														</div>
														<div className="media-body align-self-center">
															<i
																style={PrimarycolorLineTab === '1' ? { fontSize: '1.8rem', color: "#1d5b83" } : { color: "#1d5b83", fontSize: '1.8rem' }}
																className={PrimarycolorLineTab === '1' ? " float-left ml-2 pi pi-building" : "float-left ml-2 pi pi-building"}
															/>
														</div>
													</div>
													<Progress
														value={(patientCompany / orderTotal) * 100}
														className="progress-blue"
														style={{ height: '6px', borderRadius: '4px', marginTop: '8px' }}
													/>
												</Col>
											</Col>
											<Col sm="4" className='pt-2' >
												<Col sm="12" className="pr-0 pb-3">
													<img
														src={require('../../../assets/images/dashboard/iconCancell.svg')}
														style={{ width: '49px', }}
														alt="Branch Icon"
													/>
													<label className='text-center f-w-600 label-dashboard' style={{ fontSize: "16px", color: "#002940" }}>Estudios realizados</label>
													<div className="media border-after-xs pt-1">
														<div className="align-self-center mr-3">
															<h5 className="mb-0 counter digits">{examsAndProfile ?? 0}</h5>
														</div>
														<div className="media-body details pl-3 pt-0">
															<span className="mb-1 f-w-600 label-dashboard" style={{ color: "#374558" }} >Pruebas realizadas / Día</span>
														</div>
														<div className="media-body align-self-center">
															<i
																style={PrimarycolorLineTab === '1' ? { fontSize: '1.8rem', color: "#5aa3cd" } : { color: "#5aa3cd", fontSize: '1.8rem' }}
																className={PrimarycolorLineTab === '1' ? " float-left ml-2 fa fa-flask" : "float-left ml-2 fa fa-flask"}
															/>
														</div>
													</div>
													<Progress
														value={(examsAndProfile / 300) * 100}
														className="progress-dashboard3"
														style={{ height: '6px', borderRadius: '4px', marginTop: '8px' }}
													/>
												</Col>
												<Col sm="12" className="pr-0">
													<div className="media border-after-xs">
														<div className="align-self-center mr-3">
															<h5 className="mb-0 counter digits">{countTotal ?? 0}</h5>
														</div>
														<div className="media-body details pl-3 pt-0">
															<span className="mb-1 f-w-600 label-dashboard" style={{ color: "#374558" }}>Órdenes de trabajo / Mes</span>
														</div>
														<div className="media-body align-self-center">
															<i
																style={PrimarycolorLineTab === '1' ? { fontSize: '1.8rem', color: "#b8c5d1" } : { color: "#b8c5d1", fontSize: '1.8rem' }}
																className={PrimarycolorLineTab === '1' ? "float-left ml-2 fa fa-tags" : "float-left ml-2 fa fa-tags"}
															/>
														</div>
													</div>
													<Progress
														value={(countTotal / 500) * 100}
														className="progress-dashboard2"
														style={{ height: '6px', borderRadius: '4px', marginTop: '8px' }}
													/>
												</Col>
											</Col>
											<Col sm="4"  >
												<Col sm="12" className="pr-0 pb-3 pt-3" >

													<img
														src={require('../../../assets/images/dashboard/iconPdf.svg')}
														style={{ width: '37px', }}
														alt="Branch Icon"
													/>&nbsp;&nbsp;
													<label className='text-center f-w-600 label-dashboard' style={{ fontSize: "16px", color: "#002940" }}>Detalle de las ordenes</label>
													<Row>
														<Col sm="12" className='pt-1' >
															<div className="media border-after-xs">
																<div className="align-self-center mr-3">
																	<h5 className="mb-0 counter digits">{totalInvoices ?? 0}</h5>
																</div>
																<div className="media-body details pl-3 pt-0">
																	<span className="mb-1 f-w-600 label-dashboard" style={{ color: "#374558" }} >Facturado</span>
																</div>
																<div className="media-body align-self-center">
																	<i
																		style={PrimarycolorLineTab === '1' ? { fontSize: '1.8rem', color: "#bd2130" } : { color: "#bd2130", fontSize: '1.8rem' }}
																		className={PrimarycolorLineTab === '1' ? " float-left ml-2 icofont icofont-file-pdf" : "float-left ml-2 icofont icofont-file-pdf"}
																	/>
																</div>
															</div>
															<Progress
																value={(totalInvoices / orderTotal) * 100}
																className="progress-dashboard5"
																style={{ height: '6px', borderRadius: '4px', marginTop: '8px' }}
															/>
														</Col>

													</Row>
												</Col>
												<Col sm="12" className="pr-0">
													<Row>
														<Col sm="12">
															<div className="media border-after-xs">
																<div className="align-self-center mr-3">
																	<h5 className="mb-0 counter digits">{orderCancell ?? 0}</h5>
																</div>
																<div className="media-body details pl-3 pt-0">
																	<span className="mb-1 f-w-600 label-dashboard" style={{ color: "#374558" }}>Cancelado</span>
																</div>
																<div className="media-body align-self-center">
																	<i
																		style={PrimarycolorLineTab === '1' ? { fontSize: '1.8rem', color: "#bd2130" } : { color: "#bd2130", fontSize: '1.8rem' }}
																		className={PrimarycolorLineTab === '1' ? "float-left ml-2 fa fa-file-archive-o" : "float-left ml-2 fa fa-file-archive-o"}
																	/>
																</div>
															</div>
															<Progress
																value={(orderCancell / orderTotal) * 100}
																className="progress-dashboard4"
																style={{ height: '6px', borderRadius: '4px', marginTop: '8px' }}
															/>
														</Col>

													</Row>

												</Col>
											</Col>


										</Row>
									</Card>
								</Col>
							}
							{
								// * CONFIGURATION DATATABLE
							}
							<Col sm="12" >
								<div className={viewFormFilters ? "p-l-0 p-r-0" : "  d-none"}  >
									{
										PrimarycolorLineTab === "1" &&
										<Form onSubmit={(e) => getdashboard(e, true)}>
											<Row className="align-items-end">
												<Col sm="2" md="2" lg="2" className={`${typeMenu ? "" : "p-r-0 p-1"}`}>
													<Row>
														<Label className="col-12">Ingresa el NIM o Nombre</Label>
														<FormGroup className="col-md-12">
															<Input
																className='form-control form-control-sm input-air-primary b-r-9'
																name="nim"
																value={nim}
																onChange={handleInputChange}
															/>
														</FormGroup>
													</Row>
												</Col>
												<Col sm="2" className={`${typeMenu ? "" : "p-1"}`}>
													<FormGroup>
														<Label type="text" className='form-col-label'>Fecha de inicio</Label>
														<Input
															type='date'
															value={mDateRange1}
															name='mDateRange1'
															onChange={handleInputChange}
															className='form-control form-control-sm input-air-primary b-r-9'
															placeholder='YYYY-MM-DD'
														/>
													</FormGroup>
												</Col>
												<Col sm="2" className={`${typeMenu ? "" : "p-1"}`}>
													<FormGroup>
														<Label className='form-col-label'>Fecha de cierre</Label>
														<Input
															type='date'
															value={mDateRange2}
															name="mDateRange2"
															onChange={handleInputChange}
															className='form-control form-control-sm input-air-primary b-r-9'
															placeholder='YYYY-MM-DD'

														/>
													</FormGroup>
												</Col>
												<Col sm="2" md="2" lg="2" className={`${typeMenu ? "" : "p-l-0 p-r-0"}`}>
													<FormGroup>
														<Label>Estatus</Label>
														<Select
															name="mSelectStatus"
															isClearable={true}
															placeholder="Selecciona un estatus"
															noOptionsMessage={() => "Sin resultados"}
															options={ListOptionsStatus}
															onChange={(e) => handleSelectValues(e, 'mSelectStatus')}
															value={mSelectStatus}
															className="b-r-9"
															classNamePrefix="select"
															menuPortalTarget={document.body}
															styles={{
																control: (base) => ({
																	...base,
																	borderRadius: '10px',
																}),
																option: (base) => ({
																	...base,
																	borderRadius: '5px',
																}),
																menu: (base) => ({
																	...base,
																	borderRadius: '10px',
																	zIndex: 9999,
																}),
																menuPortal: (base) => ({
																	...base,
																	zIndex: 9999,
																}),
															}}
														/>
													</FormGroup>
												</Col>
												<Col className={_interfaced_hospital === "True" ? "" : "d-none"} sm="2">
													<FormGroup>
														<label htmlFor="">Tipo de Servicio</label>
														<Select
															className="input-air-primary input-xs"
															isClearable={true}
															placeholder="Selecciona un servicio"
															name="id_type_service"
															value={id_type_service}
															options={listTypeService}
															onChange={(e) => handleChangeFilterService(e, "id_type_service")}
															filterOption={filterOptions}
															menuPortalTarget={document.body}
															styles={{
																control: (base) => ({
																	...base,
																	borderRadius: '10px',
																}),
																option: (base) => ({
																	...base,
																	borderRadius: '5px',
																}),
																menu: (base) => ({
																	...base,
																	borderRadius: '10px',
																	zIndex: 9999,
																}),
																menuPortal: (base) => ({
																	...base,
																	zIndex: 9999,
																}),
															}}
														/>
													</FormGroup>

												</Col>
												<Col sm="2" className=" d-flex justify-content-start">
													<FormGroup className="d-flex" style={{ gap: "8px" }}>
														<Button
															type="submit"
															outline
															color="primary"
															size="xs"
															disabled={loading}
															className={loading ? "progress-bar-animated progress-bar-striped" : ""}
															style={{ height: '36px' }}
															title='Buscar'
														>
															<i className="pi pi-search"></i>
														</Button>
														<Button
															outline
															color="danger"
															size="xs"
															onClick={handleCleanFilter}
															title='Borrar filtro'
															style={{ height: '36px' }}
														>
															<i className='pi pi-trash'></i>
														</Button>
														<Button
															color="danger"
															size="sm"
															onClick={handleViewFilters}
															title='Ocultar flitros'
															style={{ height: '36px' }}
														>
															<i className='icofont icofont-filter f-14'></i>Ocultar
														</Button>
													</FormGroup>
												</Col>

											</Row>
										</Form>
									}
									{
										PrimarycolorLineTab === "2" &&
										<Form onSubmit={(e) => getdashboard(e, true, 0, true)}>
											<Row className="align-items-end">
												<Col sm="2" md="2" lg="2" className='p-r-0 p-1'>
													<Row>
														<Label className="col-12">Ingresa el NIM</Label>
														<FormGroup className="col-md-12">
															<Input
																className='form-control form-control-sm input-air-primary b-r-9'
																name="nim"
																value={nim}
																onChange={handleInputChange}
															/>
														</FormGroup>
													</Row>
												</Col>
												<Col sm="2" className='p-1'>
													<FormGroup>
														<Label type="text" className='form-col-label'>Fecha de inicio</Label>
														<Input
															type='date'
															value={mDateRange1}
															name='mDateRange1'
															onChange={handleInputChange}
															className='form-control form-control-sm input-air-primary b-r-9'
															placeholder='YYYY-MM-DD'
														/>
													</FormGroup>
												</Col>
												<Col sm="2" className='p-1'>
													<FormGroup>
														<Label className='form-col-label'>Fecha de cierre</Label>
														<Input
															type='date'
															value={mDateRange2}
															name="mDateRange2"
															onChange={handleInputChange}
															className='form-control form-control-sm input-air-primary b-r-9'
															placeholder='YYYY-MM-DD'

														/>
													</FormGroup>
												</Col>


												<Col sm="2" className=" d-flex justify-content-start">
													<FormGroup className="d-flex" style={{ gap: "8px" }}>
														<Button
															type="submit"
															outline
															color="primary"
															size="xs"
															disabled={loading}
															className={loading ? "progress-bar-animated progress-bar-striped" : ""}
															style={{ height: '36px' }}
															title='Buscar'
														>
															<i className="pi pi-search"></i>
														</Button>
														<Button
															outline
															color="danger"
															size="xs"
															onClick={handleCleanFilterMicro}
															title='Borrar filtro'
															style={{ height: '36px' }}
														>
															<i className='pi pi-trash'></i>
														</Button>
														<Button
															color="danger"
															size="sm"
															onClick={handleViewFilters}
															title='Ocultar flitros'
															style={{ height: '36px' }}
														>
															<i className='icofont icofont-filter f-14'></i>Ocultar
														</Button>
													</FormGroup>
												</Col>

											</Row>
										</Form>


									}
								</div>
								<Card>
									<TabContent activeTab={PrimarycolorLineTab}>
										{
											// ! CLINICAL ---------------
										}
										<TabPane className="fade show" tabId="1">
											{
												loading === true ?
													<>
														<Row>
															<Col sm="12" md="12" lg="12" className='text-center pt-5'>
																<img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "8%" }} />
															</Col>
															<Col sm="12" md="12" lg="12" className='text-center mt-1'>
																<p className='txt-secondary'>Buscando...</p>
															</Col>
														</Row>
													</>
													:
													<div className="table-responsive">
														<DataTable
															value={filterData2(nimData, globalFilter2)}
															paginator
															rows={10}
															emptyMessage={
																<div className="text-center">
																	<img
																		src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
																		style={{ width: "25%" }}
																		alt="Sin Muestras"
																	/>
																	<br />
																	<p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
																		No hay muestras disponibles.
																	</p>
																</div>
															}
															loading={loading}
															rowsPerPageOptions={[10, 50, 100]}
															stripedRows
															responsiveLayout="scroll"
															expandedRows={expandedRows2}
															onRowToggle={(e) => setExpandedRows2(e.data)}
															rowExpansionTemplate={rowExpansionTemplate2}
															header={
																<Col sm="12" md="12" lg="12" className={viewFormFilters ? 'p-r-0 p-l-0 pb-0' : 'p-r-0 pb-0'}   >

																	<Col sm="12" className={!viewFormFilters ? " p-r-0" : " "}>
																		<Row>
																			<Col sm="3" className="p-l-0 p-r-0 d-flex align-items-center gap-2">
																				{
																					<Nav className="border-tab nav-primary mb-0" tabs style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', cursor: "pointer" }}>
																						<NavItem>
																							<NavLink
																								className={PrimarycolorLineTab === '1' ? 'active pt-0 pb-0 mr-0 mt-0' : 'pt-2 pb-2 mr-0 mt-0'}
																								// onClick={() => handleView()}
																								onClick={(e) => {
																									handleView();
																									handleCleanFilter();
																								}}
																								style={PrimarycolorLineTab === '1' ? {

																									color: 'white',
																									borderRadius: '5px',
																								} : {}}
																							>
																								<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/typeService.svg")} style={{ width: "25px", height: "25px", cursor: "pointer" }} />

																								<div className="tab-with-counter">
																									{url_helen !== cedimi &&
																										(
																											<span className="tab-counter">
																												{totalClinical ?? 0}
																											</span>
																										)}

																									<label style={{ fontSize: "15px", cursor: "pointer" }} className={PrimarycolorLineTab === '1' ? 'txt-primary f-w-600' : 'txt-primary f-w-500'}>
																										Clinicos
																									</label>
																								</div>
																							</NavLink>
																						</NavItem>
																					</Nav>

																				}
																				{
																					_active_micro === "True" && (
																						<Nav className="border-tab nav-primary mb-0" tabs style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', cursor: "pointer" }}>
																							<NavItem>
																								<NavLink
																									className={PrimarycolorLineTab === '2' ? 'active' : ''}
																									// onClick={(e) => getdashboard(e, true, 0, true)}
																									onClick={(e) => {
																										// getdashboard(e, true, 0, true); 
																										handleCleanFilterMicro();
																									}}
																									style={PrimarycolorLineTab === '2' ? {
																										// backgroundColor: 'skyblue !important',
																										// borderColor: 'skyblue',
																										color: 'white',
																										borderRadius: '5px',
																										// transition: 'all 0.3s ease',
																									} : {}}
																								>
																									<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/price/microType.svg")} style={{ width: "25px", height: "25px", cursor: "pointer" }} />

																									<div className="tab-with-counter">
																										{url_helen !== cedimi && (
																											<span className="tab-counter">
																												{totalMicro ?? 0}
																											</span>

																										)}

																										{_active_micro === "True" && <label style={{ color: "#1d5b83", fontSize: "15px", cursor: "pointer" }} className={PrimarycolorLineTab === '2' ? "f-w-600" : "f-w-500"}>
																											{_title_dashboard ?? "-----"}
																										</label>}
																									</div>
																								</NavLink>
																							</NavItem>
																						</Nav>
																					)
																				}
																			</Col>
																			<Col sm="2" className="p-l-0 p-r-0 d-flex align-items-center gap-2">
																				<button
																					className="p-button p-button-success"
																					onClick={() => exportToExcel(nimDataExcel)}
																					title="Descargar reporte"
																					style={{
																						alignItems: "center",
																						padding: "5px 8px",
																						height: "35px",
																						width: "35px",
																						fontSize: "0.9rem",
																						display: "flex",
																						justifyContent: "center",
																						position: "relative"
																					}}
																				>
																					<i className="pi pi-file-excel" style={{ fontSize: "1rem" }}></i>
																				</button>
																				<div className="d-flex flex-row align-items-center gap-2">
																					<Label className="f-w-600 f-12 badge badge-light-primary mb-0">Mis admisiones</Label>
																					<Label className="switch mb-0">
																						<Input
																							type="checkbox"
																							name="my_admision"
																							id="myAdmissionSwitch"
																							checked={justMe}
																							onChange={handleSwitchChange}
																						/>
																						<span className="slider round"></span>
																					</Label>
																				</div>
																			</Col>
																			<Col sm="2" className="pt-3">

																			</Col>
																			<Col sm="2" className='pt-3'>
																				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
																					<img
																						src={require('../../../assets/images/dashboard/branch.png')}
																						style={{ width: '26px', height: '26px', marginRight: '8px' }}
																						alt="Branch Icon"
																					/>
																					<label className='f-w-600 f-14 badge label-dashboard' style={{ margin: 0, fontSize: "10px" }}>{branchName}</label>
																				</div>
																			</Col>


																			<Col sm="2" style={{ textAlign: "end" }} className='pt-3' >
																				<span className="p-input-icon-left">
																					<InputText
																						type="search"
																						className="pl-6"
																						onInput={(e) => setGlobalFilter2(e.target.value)}
																						value={globalFilter2}
																						style={{ width: "100%" }}
																						placeholder='Buscar...'
																					/>
																				</span>
																			</Col>

																			<Col sm="1" className='p-l-0 p-r-0 pt-3' >
																				<Button type="button" size="sm" outline color="secondary" onClick={handleViewFilters}>
																					<i className="icofont icofont-filter" /> Filtros

																				</Button>
																			</Col>

																		</Row>
																	</Col>
																</Col>
															}
														>
															<Column
																body={(rowData, { rowIndex }) => rowIndex + 1}
																header="#"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																sortable
																field="id_work_order"
															/>
															<Column
																body={(rowData) => (
																	<label className='pb-zero' style={{ fontSize: "11px", fontWeight: "700", textAlign: "center", paddingBottom: "0px !important" }}>
																		{rowData?.nim ?? "-----"}
																	</label>
																)}
																header="NIM"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																sortable
																field="nim"
																className={(_valid_Finance === "True" && _finance2 === "False") ? "d-none" : ""}
															/>
															<Column
																body={(rowData) => (
																	<label className='pb-zero' style={{ fontSize: "11px", fontWeight: "700", textAlign: "center", paddingBottom: "0px !important" }}>
																		{rowData?.fechAndDate ?? "-----"}
																	</label>
																)}
																header="Fecha y Hora"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																sortable
																field="fechAndDate"
															/>
															<Column
																body={(rowData) => (
																	<label className='pb-zero' style={{ fontSize: "11px", fontWeight: "700", textAlign: "center", paddingBottom: "0px !important" }}>
																		{rowData?.name_patient ?? "-----"}
																	</label>
																)}
																header="paciente"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																}}
																sortable
																field="name_patient"
															/>
															<Column
																header="Facturar"
																headerStyle={{
																	...headerStyle,
																	textAlign: "center"
																}}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "visible",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																body={(rowData) => (
																	<div
																		className={
																			rowData?.id_estatus_order === 20
																				? "d-none"
																				: "d-flex justify-content-center gap-2"
																		}
																		style={{
																			position: "relative",
																			zIndex: 9999,
																			overflow: "visible",
																		}}
																	>

																		{rowData?.self_billing === "Si" && (
																			<div
																				className="self-billing-tooltip-container"
																				style={{
																					position: "absolute",
																					right: "8px",
																					zIndex: 9999999,
																				}}
																			>
																				<img
																					alt="Self Billing"
																					src={require("../../../assets/images/billing.png")}
																					style={{
																						width: "33px",
																						height: "29px",
																						cursor: "pointer",
																						display: "block",
																						position: "relative",
																						zIndex: 100000,
																					}}
																				/>

																				<div
																					className="self-billing-tooltip"
																					style={{
																						zIndex: 999999,
																					}}
																				>
																					<div className="self-billing-tooltip-title">
																						Facturado el dia:
																					</div>

																					<div className="self-billing-tooltip-date">
																						{rowData?.date_billing}
																					</div>
																				</div>
																			</div>
																		)}


																		<button
																			onClick={() =>
																				navigateInvoice(
																					rowData?.id_work_order,
																					rowData?.id_patient,
																					rowData?.id_company,
																					rowData?.is_invoiced
																				)
																			}
																			title={
																				rowData.is_invoiced === true
																					? "Factura generada"
																					: "Generar factura"
																			}
																			style={{
																				width: "26px",
																				height: "26px",
																				fontSize: "0.65rem",
																				borderRadius: "8px",
																				padding: "0",
																				display: "flex",
																				alignItems: "center",
																				justifyContent: "center",
																				backgroundColor:
																					rowData?.is_invoiced === true
																						? (
																							rowData?.invoice_is_general_public === true
																								? "#d91e1e91"
																								: "#00000091"
																						)
																						: "#0c466a",
																				border: "none",
																				color: "#fff",
																				cursor: "pointer",
																			}}
																			className={
																				(!rowData.paid && credit_payment === "True")
																					? "d-none"
																					: ""
																			}
																		>
																			<i
																				style={{ fontSize: "14px" }}
																				className="pi pi-file-pdf"
																			></i>
																		</button>

																	</div>
																)}
															/>
															<Column
																header="Muestra"
																className={enable_tracking_toma === "True" ? "" : "d-none"}
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																body={(rowData) => {
																	if (rowData.id_estatus_order === 20) {
																		return null;
																	}
																	let { listExam: exams, listProfileWorkOrders: profiles } = rowData;

																	let completeAllProfiles = Array.isArray(profiles) && profiles.every(_exam =>
																		_exam &&
																		Array.isArray(_exam.listExam) &&
																		_exam.listExam.every(x => x.check_forwarded || x.is_toma)
																	);

																	let someProfile = Array.isArray(profiles) && profiles.some(_exam =>
																		_exam &&
																		Array.isArray(_exam.listExam) &&
																		_exam.listExam.some(x => x.check_forwarded || x.is_toma)
																	);

																	let completeAllExams = Array.isArray(exams) && exams.every(x => x.check_forwarded || x.is_toma);
																	let someExam = Array.isArray(exams) && exams.some(x => x.check_forwarded || x.is_toma);

																	let imgSrc =
																		(completeAllExams === false && someExam) ||
																			(completeAllProfiles === false && someProfile)
																			? img3
																			: ((exams.length === 0 || completeAllExams) && (profiles.length === 0 || completeAllProfiles)) || rowData.enable_tracking_toma === 'False'
																				? img4
																				: img0;

																	return (
																		<div className="d-flex justify-content-center gap-2">
																			<div
																				onClick={(e) => {

																					const triggerRef = {
																						current: e.currentTarget
																					};

																					handleTrazabilidad(
																						rowData?.id_work_order,
																						rowData?.nim2,
																						triggerRef,
																						rowData?.name_patient,
																						rowData?.gender
																					);
																				}}
																			// onClick={() => handleTrazabilidad(rowData?.id_work_order, rowData?.nim2, modalFullRef, rowData?.name_patient, rowData?.gender)}
																			// ref={modalFullRef}
																			>
																				<img className='pointer' src={imgSrc} alt="Icono" style={{ width: '28px', height: '28px' }} title={`Trazabilida del nim: ${rowData?.nim2}`} />                </div>
																		</div>
																	);
																}}
															/>
															<Column
																className={enable_tracking_toma === "True" ? "d-none" : ""}
																header="Muestra"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																body={(rowData) => {
																	if (rowData?.id_estatus_order === 20) return null;

																	let exams = rowData?.listExam ?? [];
																	let profiles = rowData?.listProfileWorkOrders ?? [];
																	let completeAllProfiles = false;
																	let someProfile = false;
																	let tmp_profile = false;
																	let tmp_incompleteProfile = false;

																	profiles.forEach((_exam, _e) => {
																		let profilesExams = _exam?.listExam;

																		completeAllProfiles = profilesExams.every(x => x?.check_forwarded === true || x?.is_toma === true);

																		someProfile = profilesExams.some(x => x?.check_forwarded === true || x?.is_toma === true);

																		let someIncompleteProfile = profilesExams.some(x => x?.check_forwarded !== true && x?.is_toma !== true);

																		if (someProfile === true) {
																			tmp_profile = true;
																		}
																		if (someIncompleteProfile === true) {
																			tmp_incompleteProfile = true;
																		}
																	})

																	let completeAllExams = exams.every(x => x?.check_forwarded === true || x?.is_toma === true);
																	let someExam = exams.some(x => x?.check_forwarded === true || x?.is_toma === true);

																	let _color =
																		(completeAllExams === false && someExam === true) ||
																			((completeAllProfiles === false || tmp_incompleteProfile === true) && (someProfile === true || tmp_profile === true)) ||
																			(completeAllProfiles === false && exams.length > 0 && profiles.length > 0 && completeAllExams === true) ||
																			(completeAllExams === false && profiles.length > 0 && exams.length > 0 && completeAllProfiles === true)
																			? 'warning'
																			: ((exams.length === 0 || completeAllExams === true) &&
																				(profiles.length === 0 || completeAllProfiles === true)) ||
																				(enable_tracking_toma === false || enable_tracking_toma === 'False')
																				? 'success'
																				: 'danger';

																	return (
																		<div className="d-flex justify-content-center gap-2">
																			<button
																				style={{
																					width: "26px",
																					height: "26px",
																					borderRadius: "8px",
																					backgroundColor: _color === "success"
																						? "#51bb25"
																						: _color === "danger"
																							? "#bd2130"
																							: "#f97314",
																					color: "#fff",
																					border: "none",
																					cursor: "pointer"
																				}}
																				onClick={() => handleModalCheckSpecimen(rowData?.id_work_order)}
																				title={`Ver detalles del nim: ${rowData?.nim2}`}
																			>
																				<i
																					className="icofont icofont-warning"
																					style={{ fontSize: "14px" }}
																				></i>
																			</button>
																		</div>
																	);
																}}
															/>
															<Column
																header="Estatus"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{
																	...cellStyle,
																	textAlign: "center",
																	width: "100px",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "top",
																	paddingBottom: 0,
																}}
																body={(rowData) => (
																	<div className="d-flex justify-content-center">
																		{renderStatusTag(rowData)}
																	</div>
																)}
																sortable
																field="id_estatus_order"
															/>
															<Column
																header="Acciones"
																headerStyle={{ ...headerStyle, textAlign: "center" }}
																style={{ ...cellStyle, textAlign: "center", width: "250px", verticalAlign: "top", paddingBottom: 0, }}
																body={(rowData) => (
																	<div
																		className={rowData?.id_estatus_order === 20 ? "d-none" : "d-flex justify-content-center"}
																		style={{ gap: "4px", alignItems: "flex-start" }}
																	>
																		<button
																			onClick={() => navigateUpdate(rowData?.id_work_order)}
																			title="Editar Orden"
																			style={buttonStyle}
																		>
																			<i style={{ fontSize: "14px" }} className="fa fa-edit"></i>
																		</button>
																		<button
																			onClick={() => printTicket(rowData?.id_work_order)}
																			title="Reimprimir Ticket"
																			style={buttonStyle5}
																		>

																			<i style={{ fontSize: "14px" }} className=" fa fa-ticket"></i>
																		</button>

																		<button
																			onClick={() => printSticker(rowData?.id_work_order)}
																			title="Etiquetas"
																			style={buttonStyle6}
																		>
																			<i style={{ fontSize: "14px" }} className="fa fa-barcode"></i>
																		</button>
																		<button
																			onClick={() => navigateConfigEtiqueta(rowData?.id_work_order)}
																			title="Detalle de impresión"
																			style={buttonStyle7}

																		>

																			<i style={{ fontSize: "14px" }} className="fa fa-clipboard"></i>
																		</button>

																		{rowData.show_print !== false && (
																			<button
																				onClick={() => handleMedical(rowData?.id_work_order)}
																				title="Previsualizar"
																				style={buttonStyle2}
																				className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																			>
																				<i style={{ fontSize: "14px" }} className="pi pi-eye"></i>
																			</button>
																		)}
																		{/* {rowData.show_print !== false && (
																				<button
																					onClick={() => handleListPrint(rowData?.id_work_order)}
																					title="Imprimir Resultado"
																					style={buttonStyle3}
																					className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																				>
																					<i style={{ fontSize: "14px" }} className="pi pi-print"></i>
																				</button>
																			)} */}
																		{!(arrayStatus.includes(rowData?.id_estatus_order)) &&
																			(
																				rowData?.send_email === true ||
																				rowData?.send_doctor === true ||
																				rowData?.send_whatsapp === true ||
																				rowData?.send_whatsapp_doctor === true ||
																				rowData?.show_print === true
																			) && (
																				<button
																					onClick={() => handleListExamEmail(rowData?.id_work_order, rowData?.nim2)}
																					title="Resultados: envío e impresión"
																					style={buttonStyle3}
																					className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																				>
																					<i style={{ fontSize: "14px" }} className="pi pi-print"></i>
																				</button>
																			)}
																		{rowData.show_print !== false && (
																			<button
																				onClick={() => handleCheckDelivery(rowData?.id_work_order)}
																				title="Entregar"
																				style={buttonStyle8}
																				className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																			>
																				<i style={{ fontSize: "14px" }} className="pi pi-check-circle"></i>
																			</button>
																		)}
																		{cedimi === _url_helen && (
																			<button
																				onClick={() => printTicketCedimi(rowData?.id_work_order)}
																				title="Orden de trabajo"
																				style={buttonStyle9}
																			>
																				<i style={{ fontSize: "14px" }} className="fa fa-file"></i>
																			</button>
																		)}
																		{rowData?.is_send_email === true && (
																			<button
																				onClick={() => handleInvoice(rowData?.id_work_order, rowData?.UUID)}
																				title="Previsualizar factura"
																				style={buttonStyle10}
																				className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																			>
																				<i style={{ fontSize: "14px" }} className="icofont icofont-file-pdf"></i>
																			</button>
																		)}
																		{rowData?.is_send_email === true && (
																			<button
																				onClick={() => sendResultForEmail(rowData?.id_work_order, rowData?.UUID)}
																				title="Enviar factura"
																				style={buttonStyle11}
																				className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																			>
																				<i style={{ fontSize: "14px" }} className="fa fa-mail-forward"></i>
																			</button>
																		)}
																		{enable_whatsapp === "True" && (
																			<button
																				onClick={() => handleSendWhatss(rowData?.id_work_order, rowData?.phone_patient)}
																				title="Envio a whatsapp"
																				style={buttonStyle8}
																				className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																			>
																				<i style={{ fontSize: "14px" }} className="icofont icofont-brand-whatsapp"></i>
																			</button>
																		)}
																	</div>
																)}
															/>
														</DataTable>
													</div>
											}
										</TabPane>
										{
											// ! MICRO ---------------
										}
										{
											_active_micro === "True" && <TabPane tabId="2">
												<Col sm="12">

													{
														loadingMicro ?
															<>
																<Row>
																	<Col sm="12" md="12" lg="12" className='text-center pt-5'>
																		<img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "8%" }} />
																	</Col>
																	<Col sm="12" md="12" lg="12" className='text-center mt-1'>
																		<p className='txt-secondary'>Buscando...</p>
																	</Col>
																</Row>
															</>
															:
															<div className="table-responsive">
																<DataTable
																	value={filterData(nimData, globalFilter)}
																	paginator
																	rows={10}
																	emptyMessage={
																		<div className="text-center">
																			<img
																				src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
																				style={{ width: "25%" }}
																				alt="Sin Muestras"
																			/>
																			<br />
																			<p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
																				No hay muestras disponibles.
																			</p>
																		</div>
																	}
																	rowsPerPageOptions={[10, 50, 100]}
																	stripedRows
																	loading={loading}
																	responsiveLayout="scroll"
																	expandedRows={expandedRows}
																	onRowToggle={(e) => setExpandedRows(e.data)}
																	rowExpansionTemplate={rowExpansionTemplate}
																	header={
																		<Col sm="12" className="p-0">
																			<Row className="align-items-center g-2">
																				<Col sm="3" className="p-l-0 p-r-0 d-flex align-items-center gap-2">
																					{
																						<Nav className="border-tab nav-primary mb-0" tabs style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', cursor: "pointer" }}>
																							<NavItem>
																								<NavLink
																									className={PrimarycolorLineTab === '1' ? 'active pt-0 pb-0 mr-0 mt-0' : 'pt-2 pb-2 mr-0 mt-0'}
																									// onClick={() => handleView()}
																									onClick={(e) => {
																										handleView();
																										handleCleanFilter();

																									}}
																									style={PrimarycolorLineTab === '1' ? {

																										color: 'white',
																										borderRadius: '5px',
																									} : {}}
																								>
																									<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/typeService.svg")} style={{ width: "25px", height: "25px", cursor: "pointer" }} />

																									<div className="tab-with-counter">
																										{url_helen !== cedimi && (
																											<span className="tab-counter">
																												{totalClinical ?? 0}
																											</span>
																										)

																										}

																										<label style={{ fontSize: "15px", cursor: "pointer" }} className={PrimarycolorLineTab === '1' ? 'txt-primary f-w-600' : 'txt-primary f-w-500'}>
																											Clinicos
																										</label>
																									</div>
																								</NavLink>
																							</NavItem>
																						</Nav>

																					}
																					{
																						_active_micro === "True" && (
																							<Nav className="border-tab nav-primary mb-0" tabs style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', cursor: "pointer" }}>
																								<NavItem>
																									<NavLink
																										className={PrimarycolorLineTab === '2' ? 'active pt-0 pb-0 mr-0 mt-0' : 'pt-0 pb-0 mr-0 mt-0'}
																										// onClick={(e) => getdashboard(e, true, 0, true)}
																										onClick={(e) => {
																											e.preventDefault();
																											handleCleanFilterMicro();
																										}}
																										style={PrimarycolorLineTab === '2' ? {
																											// backgroundColor: 'skyblue !important',
																											// borderColor: 'skyblue',
																											color: 'white',
																											borderRadius: '5px',
																											// transition: 'all 0.3s ease',
																										} : {}}
																									>
																										<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/price/microType.svg")} style={{ width: "25px", height: "25px", cursor: "pointer" }} />

																										<div className="tab-with-counter">
																											{url_helen !== cedimi && (
																												<span className="tab-counter">
																													{totalMicro ?? 0}
																												</span>

																											)

																											}


																											{_active_micro === "True" && <label style={{ color: "#1d5b83", fontSize: "15px", cursor: "pointer" }} className={PrimarycolorLineTab === '2' ? "f-w-600" : "f-w-500"}>
																												{_title_dashboard ?? "-----"}
																											</label>}
																										</div>
																									</NavLink>
																								</NavItem>
																							</Nav>
																						)
																					}
																				</Col>
																				<Col sm="1">
																					<button
																						className="p-button p-button-success"
																						onClick={() => exportToExcel2(nimData)}
																						title="Descargar reporte"
																						style={{
																							alignItems: "center",
																							padding: "5px 8px",
																							height: "35px",
																							width: "35px",
																							fontSize: "0.9rem",
																							display: "flex",
																							justifyContent: "center",
																							position: "relative"
																						}}
																					>

																						{isLoading ? (
																							<>
																								<i className="pi pi-spin pi-spinner" style={{ fontSize: "0.8rem" }} />
																								Descargando...
																							</>
																						) : (
																							<i className="pi pi-file-excel" style={{ fontSize: "1rem" }}></i>
																						)}
																					</button>

																				</Col>
																				<Col sm="2" className="pt-3">
																				</Col>
																				<Col sm="2" >
																					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
																						<img
																							src={require('../../../assets/images/dashboard/branch.png')}
																							style={{ width: '26px', height: '26px', marginRight: '8px' }}
																							alt="Branch Icon"
																						/>
																						<label className='f-w-600 f-14 badge label-dashboard' style={{ margin: 0, fontSize: "10px" }}>{branchName}</label>
																					</div>
																				</Col>
																				<Col sm="2" style={{ textAlign: "end" }}>
																					<span className="p-input-icon-left">
																						<i className="pi pi-search" />
																						<InputText
																							type="search"
																							className="pl-6"
																							onInput={(e) => setGlobalFilter(e.target.value)}
																							value={globalFilter}
																							style={{ width: "100%" }}
																						/>
																					</span>
																				</Col>
																				<Col sm="1" className='p-l-0 p-r-0 ' >
																					<Button type="button" size="sm" outline color="secondary" onClick={handleViewFilters}>
																						<i className="icofont icofont-filter" /> Filtros
																					</Button>
																				</Col>

																			</Row>
																		</Col>
																	}
																>
																	<Column
																		body={(rowData, { rowIndex }) => rowIndex + 1}
																		header="#"
																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{
																			...cellStyle,
																			textAlign: "center",
																			width: "100px",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			verticalAlign: "top",
																			paddingBottom: 0,
																		}}
																		sortable
																		field='id_work_order'
																	/>
																	<Column
																		body={(rowData) => (
																			<label className='pb-zero' style={{ fontSize: "11px", fontWeight: "700", textAlign: "center", paddingBottom: "0px" }}>
																				{rowData?.nim ?? "-----"}
																			</label>
																		)}
																		header="NIM"
																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{
																			...cellStyle,
																			textAlign: "center",
																			width: "100px",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			verticalAlign: "top",
																			paddingBottom: 0,
																		}}
																		sortable
																		field="nim"
																	/>
																	<Column
																		body={(rowData) => (
																			<label className='pb-zero' style={{ fontSize: "11px", fontWeight: "700", textAlign: "center", paddingBottom: "0px !important" }}>
																				{rowData?.fechAndDate ?? "-----"}
																			</label>
																		)}
																		header="Fecha y Hora"
																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{
																			...cellStyle,
																			textAlign: "center",
																			width: "100px",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			verticalAlign: "top",
																			paddingBottom: 0,
																		}}
																		sortable
																		field="fechAndDate"
																	/>
																	<Column
																		body={(rowData) => (
																			<label className='pb-zero' style={{ fontSize: "11px", fontWeight: "700", textAlign: "center", paddingBottom: "0px !important" }}>
																				{rowData?.name_patient ?? "-----"}
																			</label>
																		)}
																		header="paciente"
																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{
																			...cellStyle,
																			textAlign: "center",
																			width: "100px",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																		}}
																		sortable
																		field="name_patient"
																	/>


																	<Column
																		header="Facturar"

																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{
																			...cellStyle,
																			textAlign: "center",
																			width: "100px",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			verticalAlign: "top",
																			paddingBottom: 0,
																		}}
																		body={(rowData) => (
																			<div className={rowData?.id_estatus_order === 20 ? "d-none" : "d-flex justify-content-center gap-2"}>
																				<button
																					onClick={() => navigateInvoice(rowData?.id_work_order, rowData?.id_patient, rowData?.id_company, rowData?.is_invoiced)}
																					title={rowData.is_invoiced === true ? "Factura generada" : `Generar factura`}
																					style={{
																						width: "26px",
																						height: "26px",
																						fontSize: "0.65rem",
																						borderRadius: "8px",
																						padding: "0",
																						display: "flex",
																						alignItems: "center",
																						justifyContent: "center",
																						backgroundColor: rowData?.is_invoiced === true ? (rowData?.invoice_is_general_public === true ? "#d91e1e91" : "#00000091") : "#0c466a",
																						border: "none",
																						color: "#fff",
																						cursor: "pointer"
																					}}
																					className={(!rowData.paid && credit_payment === "True") ? "d-none" : ""}
																				>
																					<i style={{ fontSize: "14px" }} className="pi pi-file-pdf"></i>
																				</button>
																			</div>
																		)}
																	/>

																	<Column
																		header="Estatus"
																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{
																			...cellStyle,
																			textAlign: "center",
																			width: "100px",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			verticalAlign: "top",
																			paddingBottom: 0,
																		}}
																		body={(rowData) => (
																			<div className="d-flex justify-content-center">
																				{renderStatusTag(rowData)}
																			</div>
																		)}
																		sortable
																		field="id_estatus_order"
																	/>

																	<Column
																		header="Acciones"
																		headerStyle={{ ...headerStyle, textAlign: "center" }}
																		style={{ ...cellStyle, textAlign: "center", width: "250px" }}
																		body={(rowData) => (
																			<div className={rowData?.id_estatus_order === 20 ? "d-none" : "d-flex justify-content-center"} style={{ gap: '4px' }}>
																				<button
																					onClick={() => navigateUpdate(rowData?.id_work_order)}
																					title="Editar Orden"
																					style={buttonStyle}
																				>
																					<i style={{ fontSize: "14px" }} className="fa fa-edit"></i>
																				</button>
																				<button
																					onClick={() => printSticker(rowData?.id_work_order)}
																					title="Etiquetas"
																					style={buttonStyle6}
																				>
																					<i style={{ fontSize: "14px" }} className="fa fa-barcode"></i>
																				</button>
																				{rowData?.show_print !== false && (
																					<button
																						onClick={() => handleMedical(rowData?.id_work_order)}
																						title="Previsualizar"
																						style={buttonStyle2}
																					>
																						<i style={{ fontSize: "14px" }} className="pi pi-eye"></i>
																					</button>
																				)}
																				{rowData?.show_print !== false && (
																					<button
																						onClick={() => handleListPrint(rowData?.id_work_order)}
																						title="Imprimir Resultado"
																						style={buttonStyle3}
																					>
																						<i style={{ fontSize: "14px" }} className="pi pi-print"></i>
																					</button>
																				)}
																				{!(arrayStatus.includes(rowData?.id_estatus_order)) &&
																					(
																						rowData?.send_email === true ||
																						rowData?.send_doctor === true ||
																						rowData?.send_whatsapp === true ||
																						rowData?.send_whatsapp_doctor === true
																					) && (
																						<button
																							onClick={() => handleListExamEmail(rowData?.id_work_order, rowData?.nim2)}
																							title="Enviar a correo"
																							style={buttonStyle4}
																						>
																							<i style={{ fontSize: "14px" }} className="pi pi-envelope"></i>
																						</button>
																					)}
																			</div>
																		)}
																	/>
																</DataTable>
															</div>
													}
												</Col>
											</TabPane>
										}
									</TabContent>
								</Card>

							</Col>
						</TabPane>
					</TabContent>
				</Col >
			</div > <br /> <br />
			<ModalCheckSpecimen2
				{
				...{
					modalCheckSpecimen, toggleCheckSpecimen,
					specimensUncheck, checkSpecimens, loadingSpecimen, chek,
					treeviewRef, itemsTree, changeTree, savePendingMuestra, enable_tracking_toma

				}
				}
			/>
			<ModalPreViewMedicalOrder
				{
				...{

					typeModall, workMedicalOrderPDF, workMedicalOrderPDFDownload, toggleMedical, typeModall, modalOrdenMedical, loadingPdf
				}
				}
			/>
			<ModalPrintI
				{
				...{
					togglePrintI, typeModalPrintI, modalPrintI, dataExams, handleCheckProfile, handleCheckAll, Impresionbyexam, id_workorder_print, handleCheckAllProfile, letter, handleInputChange, loadingDownloadExams
				}
				}
			/>
			<ModalViewInvoice
				{
				...{
					toggleInvoice, typeModalInvoice, modalInvoice, InvoicePDF, loadingPdf
				}
				}
			/>
			<ModalHistoricSample
				{
				...{
					typePending, modalPending, toggleHistoric, dataSample, loadingSample, dataSendProcess2, dataSendProcess3,
					dataTrackingRecepetion
				}
				}

			/>
			<ModalTrazabilidadSampleDashboard
				{...modalProps}
				close={close}
				dataSample={dataSample}
				dataSendProcess2={dataSendProcess2}
				dataSendProcess3={dataSendProcess3}
				dataTrackingRecepetion={dataTrackingRecepetion}
				namePatient={namePatient}
				treeviewRef={treeviewRef}
				itemsTree={itemsTree}
				idGender={idGender}
				dataSection={dataSection}
				dataID={dataID}
				refusedGlobal={refusedGlobal}
				filterSections={filterSections}
				handleFilterSections={handleFilterSections}
				dataTraceability={dataTraceability}
				loadingTrazability={loadingTrazability}
				exportToExcelTrazability={exportToExcelTrazability}
			>
			</ModalTrazabilidadSampleDashboard>
			<ModalCheckDelivery
				{
				...{
					toggleCheckDelivery,
					modalCheckDelivery,
					changeEstatus, idWorkOrder, commentPatient, handleInputChange, nimData
				}
				}
			/>
			{/* <ModalSendEmail
				{
				...{ toggleExamEmail, modalCheckEmail, sendResultEmail, respuestaAPI, sendResultForEmail, sendTo, handleCheckProfile, handleCheckAll, handleListExamEmail }
				}


			/> */}
			<ModalExamsEmail
				{...{
					toggleListExamEmail,
					modalExamsEmail,
					dataExams,
					handleCheckProfile,
					handleCheckAll,
					handleCheckAllProfile,
					handleFindExam,
					respuestaAPI,
					sendResultEmail,
					sendConfig,
					handleSendEmail,
					sending,
					setStep, setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
					isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount, resetModalExamEmail,
					getFullAuditHistory, handleInputChange, letter, getStatus, _url_helen
				}}
			/>
			<ModalSendWhatsapp
				{
				...{ modalPreviewSend, toggleModalSend, validNumber, id_patient, sendResultsWhatsapp }
				}

			/>

			{
				showInvoiceAlert && (
					<AlertDataTable
						titleAlert="Factura Generada"
						visibleAlert={modalAlert}
						onHideAlert={toggleAlert}
						titleNotLoading="Aceptar"
						titleDanger="Cancelar"
						messageAlert="No se puede generar una refactura."
						alert1={false}
						titleAlert1="Debe de cancelar nim"
					/>
				)
			}
		</Fragment >
	);
}
export default Sample;

